import React from 'react';
import { Plus, Monitor, Usb, ShieldAlert, User, FileText } from 'lucide-react';
import { Button } from '../ui/Button';
import { useGraphStore } from '../../store/graphStore';
import { NodeType } from '@the-ledger/shared';

export function ControlPanel() {
    const addNode = useGraphStore((state) => state.addNode);

    const handleAddNode = (type: NodeType) => {
        addNode({
            type,
            name: `New ${type}`,
            security_checks: {},
        });
    };

    return (
        <div className="absolute top-4 left-4 bg-surface/90 backdrop-blur-md border border-border rounded-xl p-3 shadow-2xl flex flex-col gap-2 z-10 w-48">
            <h3 className="text-xs font-bold text-text-muted uppercase tracking-wider mb-1">Add Assets</h3>

            <Button variant="ghost" size="sm" className="justify-start gap-2 text-left" onClick={() => handleAddNode('DigitalAccount')}>
                <Monitor className="h-4 w-4 text-primary" />
                <span className="text-sm">Digital Account</span>
            </Button>

            <Button variant="ghost" size="sm" className="justify-start gap-2 text-left" onClick={() => handleAddNode('HardwareKey')}>
                <Usb className="h-4 w-4 text-danger" />
                <span className="text-sm">Hardware Key</span>
            </Button>

            <Button variant="ghost" size="sm" className="justify-start gap-2 text-left" onClick={() => handleAddNode('RecoveryMethod')}>
                <ShieldAlert className="h-4 w-4 text-success" />
                <span className="text-sm">Recovery Method</span>
            </Button>

            <Button variant="ghost" size="sm" className="justify-start gap-2 text-left" onClick={() => handleAddNode('Person')}>
                <User className="h-4 w-4 text-warning" />
                <span className="text-sm">Person</span>
            </Button>

            {/* Helper / Info */}
            <div className="mt-2 pt-2 border-t border-border text-[10px] text-text-muted leading-tight">
                Drag to move.<br />Double-click to edit.<br />Drag between nodes to link.
            </div>
        </div>
    );
}
